package com.exura.features.newauth.domain.manager

import com.exura.core.domain.SimpleEvent
import com.exura.features.newauth.data.repository.ProviderFirebaseAuthRepository
import com.exura.features.newauth.domain.model.AuthState
import com.exura.features.newauth.domain.model.ProviderAuthUser
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.onStart
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock

/**
 * Implementation of AuthManager for provider authentication.
 */
class ProviderAuthManager(
    private val repository: ProviderFirebaseAuthRepository,
    private val scope: CoroutineScope
) : AuthManager {

    private val _event = MutableSharedFlow<SimpleEvent>()
    override val event: Flow<SimpleEvent> = _event

    override val state: Flow<AuthState> = repository.currentUser
        .map { user ->
            if (user != null) {
                AuthState.Authenticated(user)
            } else {
                AuthState.Unauthenticated
            }
        }
        .onStart { emit(AuthState.Loading) }
        .catch { emit(AuthState.Unauthenticated) }
        .stateIn(
            scope = scope,
            started = SharingStarted.Eagerly,
            initialValue = AuthState.Loading
        )

    override suspend fun signIn(email: String, password: String) {
        try {
            repository.login(email, password).getOrThrow()
            _event.emit(SimpleEvent.Success)
        } catch (e: Exception) {
            _event.emit(SimpleEvent.Error("Niepoprawne dane użytkownika"))
        }
    }

    override fun signOut() {
        scope.launch {
            repository.logout()
        }
    }

    override suspend fun sendPasswordResetEmail(email: String): Result<Unit> {
        return repository.sendPasswordResetEmail(email)
    }
}
